import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from '@cbridge-utils/react-redux';
import { NavigationBlock } from '@cbridge-tools/navigation-block';
import { streamsNodesSubNavigationPropsSelector } from './StreamsNodesSubNavigation.selector';
import { CreateNodeButton } from '../createButton/CreateNodeButton';
import { NodeItem } from '../navigationItem/NodeItem';

export const StreamsNodesSubNavigation: FunctionComponent = () => {
  const { t } = useTranslation();

  const { items, isLoading } = useSelector(streamsNodesSubNavigationPropsSelector);

  return (
    <NavigationBlock
      header={t('text:configPage.symbolPools.pluralTitle')}
      headerAction={<CreateNodeButton />}
      items={items}
      isLoading={isLoading}
      NavigationItemComponent={NodeItem}
    />
  );
};
